export default __webpack_public_path__ + "static/media/learning-blue-icon.764b161e.svg";